import { cn } from '@vimond/theme/tailwind';
import { Artwork } from './Artwork';
import { getEnvVar } from '@vimond/utils/env';

type Props = {
  src: string;
  className?: string;
  fallbackToDefault?: boolean;
};

export const ArtworkLogo = ({ className, fallbackToDefault, src }: Props) => {
  if (!src) return null;
  if (getEnvVar('NEXT_PUBLIC_ARTWORK_LOGO_ENABLED') === 'false') return null;
  return (
    <Artwork
      src={src}
      alt=""
      location="thumb"
      fallbackToDefault={fallbackToDefault}
      width={300}
      height={200}
      className={cn('my-3 h-auto max-w-[80%] rounded-md', className)}
    />
  );
};
